/**
 * This is the rsaRegister controller.
 * @memberOf securityquestion Module
 * @namespace rsaRegister Controller
 */

/**
 * @name rsaRegisterController
 * @desc Create the controller.
 * @param $scope
 * @param coreService
 * @memberOf securityquestion Module.rsaRegister Controller
 * @ngInject
 */
function rsaRegisterController($scope, $translate, coreService, deviceprintFn, whitelabel) {
    var vm = this;
    // Register the view model's properties.
    vm.validateForm = validateForm;
    vm.isDifferentAnswer = isDifferentAnswer;
    vm.alertConfirmation = alertConfirmation;
    vm.submitted = false;
    vm.messages = [];

    // Activate the controller.
    activate();

    function activate() {
        // Read Identity Server's data model
        var model = coreService.getIdentityModel();

        if (model.custom && model.custom.ui_locales) {
            $translate.use(model.custom.ui_locales);
        }

        if (!model.selectedQuestions) {
            model.selectedQuestions = [];
        }

        $scope.model = model;

        if(deviceprintFn !== null && deviceprintFn !== undefined && typeof deviceprintFn === 'function')
        {
          if(whitelabel !== null && whitelabel !== undefined && whitelabel === 'bmo')
          {
            $scope.device_print = deviceprintFn();
          }
        }       
    }

    function isDifferentAnswer(index) {
        if ($scope.model.selectedQuestions) {
            for (var i = 0; i < $scope.model.selectedQuestions.length; i++) {
                if (i != index &&
                    $scope.model.selectedQuestions[index] &&
                    $scope.model.selectedQuestions[i].answer == $scope.model.selectedQuestions[index].answer) {
                    return true;
                }
            }
        }

        return false;
    }

    function alertConfirmation(event) {
        event.preventDefault();   
        $translate('securityquestion.form.cancel_confirmation_text')
        .then(function(data) {
            if (confirm(data)) {
                window.location.href = "/logout";
            }
      });
     }

    // Validate the login account form.
    function validateForm(e) {
        // Update the form.
        vm.messages = [];
        vm.submitted = true;

        if ($scope.registerForm.$invalid) {
            // Move focus to first invalid input field
            var invalidInput = document.querySelector('input.ng-invalid');
            if (invalidInput) {
                invalidInput.focus();
            }
            var invalidSelect = document.querySelector('select.ng-invalid');
            if (invalidSelect) {
                invalidSelect.focus();
            }

            // Do not submit
            e.preventDefault();
        }
    }
}

export default rsaRegisterController;


// WEBPACK FOOTER //
// ./src/login/securityquestion/rsa/register/rsa.register.controller.js